





































































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";
import ReplaceDevice from "./replacedeviceId.vue";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PageUserRequest extends PageRequest {
  keyword: string;
  tenantId: number;
  typeId: number;
  ispId: number;
  startTime: string;
  endTime: string;
}

@Component({
  components: { ReplaceDevice },
})
export default class DeviceTenants extends AbpBase {
  pagerequest: PageUserRequest = new PageUserRequest();
  deviceModalShow: boolean = false;
  treedata: any[] = [];
  treeDataList: any[] = [];
  tenantlist: any[] = [];
  splitnum: number = 0.15;
  deviceId: string = "";
  searchName: string = ""; //树形搜索名称
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  //选中
  handleRowChange(currentRow, oldCurrentRow) {
    this.deviceId = currentRow.deviceId;
  }
  get list() {
    return this.$store.state.devicetenant.list;
  }
  get loading() {
    return this.$store.state.devicetenant.loading;
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.treedata = this.treeDataList;
      return;
    }
    const rebuildData = (value, treeList) => {
      let newarr = [];
      treeList.forEach((element) => {
        if (element.children && element.children.length) {
          if (element.children && element.title.indexOf(value) > -1) {
            element.expand = true;
            newarr.push(element);
          }
          const ab = rebuildData(value, element.children);
          const obj = {
            ...element,
            expand: true,
            children: ab,
          };
          if (ab && ab.length) {
            newarr.push(obj);
          }
        } else {
          if (element.children && element.title.indexOf(value) > -1) {
            newarr.push(element);
          }
        }
      });
      return newarr;
    };
    this.treedata = [];
    this.treedata = rebuildData(value, treeList);
  }
  //更换平台Id
  replacedeviceid() {
    if (this.deviceId == "" || this.deviceId == null) {
      this.$Modal.info({
        title: this.L("Tips"),
        content: this.L("PleasChoose") + this.L("Meter"),
      });
      return;
    }
    this.deviceModalShow = true;
  }
  async itemtree() {
    await this.$store
      .dispatch("tenant/getAllTenants")
      .then((val) => {
        this.treedata = val;
        this.treeDataList = val;
        if (val[0].children.length > 0) {
          val[0].children.forEach((ele) => {
            this.tenantlist.push({ id: ele.id, title: ele.title });
          });
        }
      })
      .catch((err) => {
        //return null;
      });
  }
  pageChange(page: number) {
    this.$store.commit("devicetenant/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("devicetenant/setPageSize", pagesize);
    this.getpage();
  }
  changeSort(key) {
    this.pagerequest.sorting = key.key + " " + key.order;
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.tenantId = Number.parseInt(item[0].id);
    }
    this.$store.commit("devicetenant/setCurrentPage", 1);
    this.getpage();
  }
  getSearch() {
    this.$store.commit("devicetenant/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "devicetenant/getAll",
      data: this.pagerequest,
    });
  }
  changdate(val) {
    if (val.length > 1) {
      this.pagerequest.startTime = val[0];
      this.pagerequest.endTime = val[1];
    }
  }
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      let ispl = detaillist.filter((p) => {
        return p.itemId == 3;
      });
      ispl.forEach((ele) => {
        this.$data.ispType.push({ label: ele.name, value: ele.id });
      });
    }
  }
  get pageSize() {
    return this.$store.state.devicetenant.pageSize;
  }
  get totalCount() {
    return this.$store.state.devicetenant.totalCount;
  }
  get currentPage() {
    return this.$store.state.devicetenant.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 80,
      align: "left",
      fixed: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("Tenants"),
      key: "tenantId",
      width: 160,
      sortable: true,
      render: (h: any, params: any) => {
        let id = params.row.tenantId;
        let str = this.L("Unknown");
        if (this.tenantlist.length > 0) {
          let item = this.tenantlist.filter((p) => {
            return p.id == id;
          });
          if (item.length > 0) {
            str = item[0].title;
          }
        }

        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: str,
            },
          },
          str
        );
      },
    },
    {
      title: this.L("DeviceNo"),
      key: "deviceNo",
      sortable: true,
      fixed: "left",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.deviceNo,
            },
          },
          params.row.deviceNo
        );
      },
    },
    {
      title: this.L("Imei"),
      key: "imei",
      fixed: "left",
      sortable: true,
      width: 160,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.imei,
            },
          },
          params.row.imei
        );
      },
    },
    {
      title: this.L("Device") + "Id",
      key: "deviceId",
      sortable: true,
      width: 260,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.deviceId,
            },
          },
          params.row.deviceId
        );
      },
    },

    {
      title: this.L("Platform") + "Id",
      key: "ispDeviceId",
      sortable: true,
      width: 260,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.ispDeviceId,
            },
          },
          params.row.ispDeviceId
        );
      },
    },
    {
      title: this.L("ISP"),
      key: "ispId",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        let id = params.row.ispId;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("Platform") + this.L("Tenants") + "Id",
      key: "platformId",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.platformId,
            },
          },
          params.row.platformId
        );
      },
    },
    {
      title: this.L("DeviceType"),
      key: "typeId",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        let id = params.row.typeId;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("CreationTime"),
      key: "createTime",
      sortable: true,
      width: 160,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.createTime == null
            ? ""
            : new Date(params.row.createTime).toLocaleString("zh", {
              hour12: false,
            })
        );
      },
    },
    {
      title: this.L("CreatorUser"),
      key: "createUser",
      sortable: true,
      width: 130,
    },
    {
      title: this.L("UpdateTime"),
      key: "updateTime",
      sortable: true,
      width: 160,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.updateTime == null
            ? ""
            : new Date(params.row.updateTime).toLocaleString("zh", {
              hour12: false,
            })
        );
      },
    },
    {
      title: this.L("UpdateUser"),
      key: "updateUser",
      sortable: true,
      width: 130,
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      fixed: "right",
      width: 130,
      render: (h: any, params: any) => {
        let replaceDeviceId = this.checkButtonAuth('replaceDeviceId');
        return h("div", [
          replaceDeviceId ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.deviceId = params.row.deviceId;
                  this.replacedeviceid();
                },
              },
            },
            this.L("Replace")
          ) : '',
        ]);
      },
    },
  ];
  async created() {
    this.getItemDetail();
    await this.itemtree();
    this.pagerequest.startTime = Moment()
      .add(-7, "days")
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.pagerequest.endTime = Moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    this.getpage();
  }
  data() {
    return {
      ispType: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
      datepicker: {
        shortcuts: [
          {
            text: this.L("OneWeek"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            },
          },
          {
            text: this.L("OneMonth"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            },
          },
          {
            text: this.L("ThreeMonths"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            },
          },
        ],
      },
    };
  }
}
